var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyStateDraftsMoved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 164,
    viewBox: "0 0 182 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.982 22.5H122.738C111.062 22.5 100.175 25.8779 91 31.7097C81.8255 25.8779 70.9381 22.5 59.2618 22.5C26.5421 22.5 0.0175781 49.0245 0.0175781 81.7442V140.988H59.2618C70.9381 140.988 81.8255 137.61 91 131.779C100.175 137.61 111.062 140.988 122.738 140.988C155.458 140.988 181.983 114.464 181.983 81.7442L181.982 81.6697V22.5Z",
    fill: "#F7F8F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2773 158.953C94.4805 163.699 87.2031 163.699 83.4062 158.953C67.2695 138.387 30.25 89.3438 30.25 61.5C30.25 27.9609 57.4609 0.75 91 0.75C124.539 0.75 151.75 27.9609 151.75 61.5C151.75 89.3438 114.73 138.387 98.2773 158.953ZM91 31.125C86.5703 31.125 83.4062 34.6055 83.4062 38.7188V74.1562C83.4062 78.5859 86.5703 81.75 91 81.75C95.1133 81.75 98.5938 78.5859 98.5938 74.1562V38.7188C98.5938 34.6055 95.1133 31.125 91 31.125ZM80.875 102C80.875 107.695 85.3047 112.125 91 112.125C96.3789 112.125 101.125 107.695 101.125 102C101.125 96.6211 96.3789 91.875 91 91.875C85.3047 91.875 80.875 96.6211 80.875 102Z",
    fill: "#A8E5F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5938 38.7188V74.1562C98.5938 78.5859 95.1133 81.75 91 81.75C86.5703 81.75 83.4062 78.5859 83.4062 74.1562V38.7188C83.4062 34.6055 86.5703 31.125 91 31.125C95.1133 31.125 98.5938 34.6055 98.5938 38.7188ZM91 112.125C85.3047 112.125 80.875 107.695 80.875 102C80.875 96.6211 85.3047 91.875 91 91.875C96.3789 91.875 101.125 96.6211 101.125 102C101.125 107.695 96.3789 112.125 91 112.125Z",
    fill: "#008299"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateDraftsMoved);
export default __webpack_public_path__ + "static/media/empty-state-drafts-moved.33cd1139e2d2991991d5d76c2106409a.svg";
export { ForwardRef as ReactComponent };